import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import undefsafe from 'undefsafe'
import classNames from 'classnames/bind'

import menuBuilder from './menuBuilder'
import UserIcon from '../../../icons/user'

import styles from './signedInMenu.module.css'

class SignedInMenu extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    currentSite: PropTypes.string.isRequired
  }

  blockTitle (entry) {
    return (
      <li key={entry.title} className={styles.title}>
        {entry.title}
      </li>
    )
  }

  blockEntry (entry) {
    let cx = classNames.bind(styles)

    const { user } = this.props
    const credit = '$' + undefsafe(user, 'profile.total_deposits')
    const entryClassNames = cx(styles.dropdownItem,
      { dropdownItemLast: entry.isLastEntry })
    const linkClassNames = cx(styles.dropdownLink,
      { dropdownLinkLast: entry.isLastEntry })

    return (
      <li className={entryClassNames} key={entry.label}>
        <a href={entry.path} className={linkClassNames}>
          <span className={styles.dropdownLinkText}>
            {entry.label}
          </span>
        </a>
        { entry.showCredit &&
          <p className={styles.dropdownText}>{entry.creditLabel} {credit}</p>
        }
      </li>
    )
  }

  /*
   build the user entries if the user has been loaded and there is a valid
   profile. Returns an empty array instead if the user does not have the profile
  */
  userMenuEntries () {
    const { user, currentSite } = this.props

    if (user && user.profile) {
      return menuBuilder(user, currentSite)
    } else {
      return []
    }
  }

  render () {
    const { user } = this.props
    const earnings = undefsafe(user, 'profile.available_earnings')
    const earningsLabel = '$' + earnings
    const hasPositiveEarnings = parseInt(earnings) > 0
    const username = undefsafe(user, 'profile.username')

    return (
      <li className={styles.itemWithDropdown}>
        <Link to='#' className={styles.link}>
          <UserIcon className={styles.icon}
            width='16px' height='16px' />
          <span className={styles.linkTextTruncated}>
            {username}
          </span>
          {hasPositiveEarnings &&
            <span className={styles.linkText} data-test-selector='earningsLabel'>
              Earnings: {earningsLabel}
            </span>
          }
        </Link>

        <div className={styles.dropdownContainer}>
          <div className={styles.dropdown}>
            <ul className={styles.dropdownList}>
              {
                this.userMenuEntries().map((entry) => {
                  return (entry.title
                    ? this.blockTitle(entry) : this.blockEntry(entry)
                  )
                })
              }
            </ul>
          </div>
        </div>
      </li>
    )
  }
}

export default SignedInMenu



// WEBPACK FOOTER //
// ./client/components/siteHeader/header/user/signedInMenu.js